import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAPIService from "@hooks/useAPIService";
import { RentPaymentMethod } from "@sharedtypes/RentPaymentMethod";

const useSetRentPaymentMethod = () => {
  const apiService = useAPIService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (rentPaymentMethod: RentPaymentMethod) =>
      apiService.fetch("setRentPaymentMethod", { rentPaymentMethod }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['details'] });
    },
  });
};

export default useSetRentPaymentMethod;
